import script from "./ServiceMultiSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceMultiSelect.vue?vue&type=script&setup=true&lang=js"

import "./ServiceMultiSelect.vue?vue&type=style&index=0&id=30d9231a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30d9231a"]])

export default __exports__